import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import CpeHistoryImport from '../CpeHistoryImport';
import tenantService from '../../services/tenantService';

/**
 * System admin: firm-wide spreadsheet import for one tenant, reached from its detail page.
 * Same page as the tenant admin's, scoped by the route's tenant id.
 */
export default function TenantCreditImport() {
  const { tenantId } = useParams<{ tenantId: string }>();
  const [tenantName, setTenantName] = useState<string | null>(null);

  useEffect(() => {
    if (!tenantId) return;
    let cancelled = false;
    tenantService
      .getTenantById(tenantId)
      .then((tenant) => {
        if (!cancelled) setTenantName(tenant?.name ?? null);
      })
      .catch(() => {
        // The back link falls back to a generic label; the import itself does not need the name.
      });
    return () => {
      cancelled = true;
    };
  }, [tenantId]);

  if (!tenantId) return null;

  return (
    <CpeHistoryImport
      key={tenantId}
      tenantId={tenantId}
      scopeName={tenantName ?? undefined}
      backTo={{ to: `/app/system-admin/tenants/${tenantId}`, label: tenantName ?? 'Tenant' }}
    />
  );
}
